
'use client';

import { Heading } from '@/components/ui/Heading';
import Image from 'next/image';
import Link from 'next/link';
import { getSiteConfig } from '@/core/config/theme-config';
import { cn } from '@/core/lib/utils';

interface ImageInfo {
    url: string;
}

interface GridItem {
    title?: string | null;
    buttonContent?: string | null;
    link?: string | null;
    image: ImageInfo;
}

interface ThirdgridProps {
    data?: {
        items?: GridItem[];
    };
}

export default function Thirdgrid({ data }: ThirdgridProps) {
    const { siteName } = getSiteConfig();
    const isArozh = siteName === "arozhdecor";

    if (!data || !data.items || data.items.length < 3) {
        return null;
    }

    const items = data.items;

    const renderCard = (
        item: GridItem,
        aspectRatioClass: string = 'aspect-video'
    ) => {
        return (
            <div className={`relative w-full overflow-hidden group ${aspectRatioClass}`}>
                {item.image && <Image
                    src={item.image.url}
                    alt={item.title || 'image'}
                    fill
                    className="object-cover rounded-md"
                />}

                {isArozh && (
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent rounded-md" />
                )}

                {(item.title || item.buttonContent) && (
                    <div
                        className={cn(
                            "absolute bottom-0 right-0 space-y-1 p-6 w-full flex flex-col items-start z-10",
                            isArozh ? "text-white" : "text-primary-900"
                        )}
                    >
                        {item.title && <Heading level={2} className={isArozh ? "text-white" : undefined}>{item.title}</Heading>}

                        {item.buttonContent && (
                            <Link
                                href={item.link || '#'}
                                className={cn(
                                    "inline-block border-b text-xs",
                                    isArozh ? "border-white text-white" : "border-primary-900"
                                )}
                            >
                                {item.buttonContent}
                            </Link>
                        )}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="col-span-12 grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="col-span-1 md:col-span-3">
                {renderCard(items[0], 'aspect-video md:h-full')}
            </div>

            <div className="grid grid-rows-2 col-span-1 md:col-span-2 gap-4">
                <div className="h-full">{renderCard(items[1])}</div>
                <div className="h-full">{renderCard(items[2])}</div>
            </div>
        </div>
    );
}